var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container-ca-datasheet"}},[_c('hot-table',{ref:"ca_datasheet",attrs:{"settings":_vm.settings}}),(_vm.loading_inicial_data && _vm.is_loading)?_c('v-progress-linear',{attrs:{"indeterminate":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }